export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/entities.worker.3f79b94f.worker.js");
}
